import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGlobalContext } from '../GlobalContext';

import Button from '../components/Button';
import './Login.scss';

const Login = () => {
  const { setToken } = useGlobalContext();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URI}/auth/login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, password }),
        },
      );

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();
      const token = data?.token;
      localStorage.setItem('token', token);
      setToken(token);
      navigate('/chat');
    } catch (error) {
      toast.error(
        'Login failed. Please check your email and password and try again.',
      );
    }
  };

  return (
    <form className="login-wrapper" onSubmit={handleSubmit}>
      <header className="header">Sign in to Gen AI Travel Planner</header>
      <input
        type="email"
        className="input-text"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        required
      />
      <input
        type="password"
        className="input-text"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        required
      />
      <Button type="submit" className="btn-lg btn-login">
        Sign In
      </Button>
    </form>
  );
};

export default Login;
